import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ArrowLeft, ArrowRight } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => { api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setPost(false)); }, [slug]);

  if (post === false) return <div className="max-w-3xl mx-auto px-4 py-20 text-center text-slate-500">Post not found. <Link to="/blog" className="text-amber font-semibold">Back to blog</Link></div>;
  if (!post) return <div className="max-w-3xl mx-auto px-4 py-20" />;

  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <Link to="/blog" className="inline-flex items-center gap-1.5 text-sm text-amber font-semibold mb-6"><ArrowLeft className="w-4 h-4" /> All articles</Link>
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slateink leading-tight">{post.title}</h1>
      <div className="aspect-[16/9] rounded-2xl overflow-hidden my-7"><img src={post.image} alt={post.title} className="w-full h-full object-cover" /></div>
      <div className="prose prose-slate max-w-none text-slate-700 leading-relaxed [&_h3]:font-display [&_h3]:text-xl [&_h3]:font-bold [&_h3]:text-slateink [&_h3]:mt-6 [&_p]:mt-4" dangerouslySetInnerHTML={{ __html: post.body }} />
      <div className="mt-10 rounded-2xl bg-subtle p-6 text-center">
        <p className="font-display text-xl font-bold text-slateink">Ready to create your own keepsake?</p>
        <Button asChild className="rounded-full bg-amber hover:bg-amber-600 text-white font-semibold mt-4"><Link to="/shop">Browse products <ArrowRight className="w-4 h-4 ml-1" /></Link></Button>
      </div>
    </article>
  );
}
